import { openBlock as t, createElementBlock as l, createElementVNode as o } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function r(a, e) {
  return t(), l("svg", n, [...e[0] || (e[0] = [
    o("path", {
      fill: "currentColor",
      d: "M5.843 17.657q-1.33-1.33-1.35-3.162-.022-1.83 1.28-3.131l5.94-5.94q.932-.933 2.277-.918 1.344.015 2.3.97.954.954.969 2.298t-.918 2.278l-5.374 5.374a1.9 1.9 0 0 1-1.424.585 2 2 0 0 1-1.437-.617 2 2 0 0 1-.617-1.437 1.9 1.9 0 0 1 .585-1.424l5.374-5.373.868.867-5.374 5.374a.8.8 0 0 0 .013 1.144.8.8 0 0 0 .575.25.76.76 0 0 0 .569-.237l5.374-5.374q.593-.594.585-1.423a2 2 0 0 0-.617-1.437 2 2 0 0 0-1.437-.617 1.9 1.9 0 0 0-1.424.585l-5.94 5.94q-.933.932-.918 2.277.015 1.344.97 2.3.955.954 2.299.969 1.345.015 2.278-.918l5.94-5.94.867.868-5.94 5.94q-1.3 1.3-3.131 1.28t-3.162-1.351"
    }, null, -1)
  ])]);
}
const d = { render: r };
export {
  d as default,
  r as render
};
